export const breazeConfig = {
  AppTheme: {
    primaryColor: '#4AC9E3',
    secondaryColor: '#f7ea48',
    tertiaryColor: '#D9D6D4',
    logo: "url('https://breas3.com/logo.png')",
  },
};
